/*global
gsap,
ScrollTrigger,
Splide,
jQuery,
Masonry,
Mmenu
 */
/*eslint no-undef: "error"*/
/*eslint-env browser*/

// Make jQuery available if needed
const $j = jQuery.noConflict();


//// Site functions ////

// Hide me show me header
function headerHideShow() {
    // let didScroll;
    // let lastScrollTop = 0;

    // const delta = 5;
    // const navbar = document.querySelector("#site-header");
    // const navbarHeight = navbar.offsetHeight;

    // window.addEventListener("scroll", () => {
    //     didScroll = true;
    // });

    // setInterval(function() {
    //     if (didScroll) {
    //         hasScrolled();
    //         didScroll = false;
    //     }
    // }, 250);

    // function hasScrolled() {
    //     let st = window.pageYOffset;

    //     if (Math.abs(lastScrollTop - st) <= delta) return;

    //     if (st > lastScrollTop && st > (navbarHeight * 2)) {
    //         // Scroll Down
    //         navbar.classList.remove("nav-down");
    //         navbar.classList.add("nav-up");
    //     } else {
    //         // Scroll Up
    //         if (st + window.innerHeight < document.body.clientHeight) {
    //             navbar.classList.remove("nav-up");
    //             navbar.classList.add("nav-down");
    //         }
    //     }

    //     lastScrollTop = st;
    // }
}


// Smooth scroll
function smoothScroll() {
    const links = document.querySelectorAll("a[href*='#']:not([href='#']):not([href='#0'])");

    for (const link of links) {
        link.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop;

        scroll({
            top: offsetTop - 130,
            behavior: "smooth"
        });
    }
}

function cartBtnFix() {

    $j('.event-cart-register-button.event-cart-button.button').on('click', function(event) {
        event.preventDefault();
        window.location.href = jQuery(this).attr('href');
    });

}

// GSAP animations
// Animate on scroll (GSAP)
// - add scripts that apply to your results here

function gsapAnimateScroll() {
    const faders = gsap.utils.toArray("[data-vas='fade']");

    if (typeof(faders) != 'undefined' && faders != null) {

        faders.forEach((fader) => {

            gsap.set(fader, {
                autoAlpha: 0
            });

            // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
            let faderDelay;

            if (fader.hasAttribute("data-vas-delay")) {
                faderDelay = fader.getAttribute("data-vas-delay");
            } else {
                faderDelay = 0;
            }
            
            ScrollTrigger.create({
                trigger: fader,
                start: "25% bottom",
                //markers: true,
                onEnter: () =>
                    gsap.to(fader, {
                        autoAlpha: 1,
                        duration: 1,
                        delay: faderDelay,
                        overwrite: true
                    }),
                onLeave: () =>
                    gsap.to(fader, {
                        autoAlpha: 0,
                        overwrite: true
                    }),
                onEnterBack: () =>
                    gsap.to(fader, {
                        autoAlpha: 1,
                        duration: 1,
                        overwrite: true
                    }),
                onLeaveBack: () =>
                    gsap.to(fader, {
                        autoAlpha: 0,
                        overwrite: true
                    })
            });
        });

    } else {
        return;
    }
}

//// Key site elements ////
function headerParallax() {
    const headBg = document.querySelector(".bg-parallax");

    if (typeof(headBg) != 'undefined' && headBg != null) {

        //let nav = document.querySelector("#site-navigation");
        //let navHeight = nav.offsetHeight;

        gsap.to(headBg, {
            y: 200,
            scrollTrigger: {
                trigger: headBg,
                start: "top 90px", //start: "top " + navHeight + "px"
                scrub: true
            }
        });

    }

}

function navDesktop() {
    let $menuItem = $j("#menu-main__desktop > li.menu-item-has-children");
    let $subMenu = $j("#menu-main__desktop > li.menu-item-has-children > ul.sub-menu");

    $menuItem.on("click", function() {
        $j(this).toggleClass("active");
        $j(this).find($subMenu).fadeToggle();
        $j(this).siblings($menuItem).removeClass("active");
        $j(this).siblings($menuItem).find($subMenu).fadeOut();
    });

    $j(document).click(function(event) {
        var $target = $j(event.target);
        if (!$target.closest($menuItem).length &&
            $subMenu.is(":visible")) {
            $subMenu.fadeOut();
            $menuItem.removeClass("active");
        }
    });
}

function navMobile() {
    const navOpen = document.querySelector("#nav-open");
    const navClose = document.querySelector("#nav-close");
    const navContainer = document.querySelector("#nav-mobile");

    navOpen.addEventListener("click", function() {
        gsap.to(navContainer, {
            display: "block"
        });
        gsap.to(navContainer, {
            autoAlpha: 1
        });
        document.documentElement.classList.add("noscroll");
    });

    navClose.addEventListener("click", function() {
        gsap.to(navContainer, {
            autoAlpha: 0
        });
        gsap.to(navContainer, {
            display: "none"
        });
        document.documentElement.classList.remove("noscroll");
    });
}

function navMmenu() {

    new Mmenu("#menu-inner", {
        wrappers: ["wordpress"],
        offCanvas: false,
        navbar: {
            sticky: false,
            title: "Explore THSP"
        },
        extensions: [
            "border-none",
            "fullscreen",
            "fx-panels-slide-100"
        ]
    });
}

function siteSearch() {
    const searchOpen = document.querySelector("#search-open");
    const searchClose = document.querySelector("#search-close");
    const searchModal = document.querySelector("#site-search");

    searchOpen.addEventListener("click", function() {
        searchModal.style.display = "flex";
    });

    searchClose.addEventListener("click", function() {
        searchModal.style.display = "none";
    });

}


//// Flexible content functions ////

// Accordion
function flxAccordion() {
    const accordions = document.querySelectorAll(".flx-accordion__row");

    if (typeof(accordions) != 'undefined' && accordions != null) {

        const openAccordion = (accordion) => {
            const heading = accordion.querySelector(".flx-accordion__row-heading");
            const content = accordion.querySelector(".flx-accordion__row-content");
            heading.classList.add("active");
            content.classList.add("open");
            content.style.maxHeight = content.scrollHeight + "px";
        };

        const closeAccordion = (accordion) => {
            const heading = accordion.querySelector(".flx-accordion__row-heading");
            const content = accordion.querySelector(".flx-accordion__row-content");
            heading.classList.remove("active");
            content.classList.remove("open");
            content.style.maxHeight = null;
        };

        accordions.forEach((accordion) => {
            const intro = accordion.querySelector(".flx-accordion__row-heading");
            const content = accordion.querySelector(".flx-accordion__row-content");

            intro.onclick = () => {
                if (content.classList.contains("open")) {
                    closeAccordion(accordion);
                } else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            };
        });

    } else {
        return;
    }
}

// Download: Feature
/* function flxDownloadFeature() {

    const dlFeat = document.querySelectorAll(".flx-dlfeature");

    if (typeof(dlFeat) != 'undefined' && dlFeat != null) {

        dlFeat.forEach((dl) => {
            const open = dl.querySelector(".open-modal");
            const close = dl.querySelector(".close-modal");
            const modal = dl.querySelector(".flx-dlfeature__modal");

            if (typeof(open) != 'undefined' && open != null) {
                open.onclick = () => {
                    modal.classList.add("modal-open");
                    document.documentElement.classList.add("noscroll");
                };
            }
            close.onclick = () => {
                modal.classList.remove("modal-open");
                document.documentElement.classList.remove("noscroll");
            };
        });

    } else {
        return;
    }

} */

// Testimonial slider
function flxTestimonialSlider() {
    const slider = document.querySelector(".flx-testfeed__slider");

    if (typeof(slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            updateOnMove: true,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 8000,
            speed: 800
        });
        splide.mount();

    } else {
        return;
    }
}

// CS slider
function flxCsSlider() {
    const slider = document.querySelector(".flx-csfeed__slider");

    if (typeof(slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'fade',
            updateOnMove: true,
            arrows: 'slider',
            pagination: false,
            //autoplay: true,
            //interval: 5000,
            speed: 800
        });
        splide.mount();

    } else {
        return;
    }
}

function flxLogoSlider() {
    const slider = document.querySelector(".flx-logos-carousel__slider");

    if (typeof(slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'slide',
            updateOnMove: true,
            arrows: false,
            perPage: 5,
            pagination: true,
            autoplay: true,
            speed: 800,
            breakpoints: {
                1024: {
                    perPage: 3
                },
                768: {
                    perPage: 2
                }
          }
        });
        splide.mount();

    } else {
        return;
    }
}


//// Other pages ////
function khMasonry() {
    let msnryContainer = document.querySelector('.kh-listing__posts');

    if (typeof(msnryContainer) != 'undefined' && msnryContainer != null) {

        let msnry = new Masonry(msnryContainer, {
            // options
            itemSelector: '.kh-listing__entry-wrap',
            columnWidth: '.msnry-col',
            gutter: '.msnry-gut',
            percentPosition: true
        });

        msnry.layout();

    } else {
        return;
    }

}

//// Utility functions ////

// DOM Ready
var DOMReady = function(callback) {
    if (
        document.readyState === "interactive" ||
        document.readyState === "complete"
    ) {
        callback();
    } else if (document.addEventListener) {
        document.addEventListener("DOMContentLoaded", callback());
    } else if (document.attachEvent) {
        document.attachEvent("onreadystatechange", function() {
            if (document.readyState != "loading") {
                callback();
            }
        });
    }
};


//// Let's go! ////
DOMReady(function() {

    headerHideShow();

    navDesktop();
    navMobile();
    navMmenu();
    cartBtnFix();
    siteSearch();

    smoothScroll();

    gsapAnimateScroll();  

    // Allows ScrollTrigger to work after ALM has done its Ajax thing
    window.almComplete = function() {
        ScrollTrigger.refresh();
    };     

    headerParallax();

    flxAccordion();
    //flxDownloadFeature(); 
    flxTestimonialSlider(); 
    flxLogoSlider(); 

    flxCsSlider();

    khMasonry();

    $j(document).on("sf:ajaxfinish", ".searchandfilter", function() {
        khMasonry();
        gsapAnimateScroll();        
    });   

});


//// Preloader ///
const preloader = document.querySelector("#page-preloader");

function handlePreloader() {
    if (preloader.classList.contains("loaded")) {
        preloader.classList.remove("loaded");
    }
    setTimeout(function() {
        preloader.classList.add("loaded");
    }, 600);
}
window.addEventListener("load", handlePreloader);